<template>
  <div style="margin-top:30px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="100px"
    >
      <el-row>
        <el-form-item
          label="联系人"
          prop="name"
          style="margin-right:15px"
        >
          <el-input
            v-model.trim="form.name"
            placeholder="请输入联系人"
          />
        </el-form-item>
        <el-form-item
          label="手机号"
          prop="phone"
          style="margin-right:15px"
        >
          <el-input
            v-model="form.phone"
            placeholder="请输入手机号"
          />
        </el-form-item>
        <el-form-item
          label="加油站名称"
          prop="gasName"
          style="margin-right:15px"
        >
          <el-input
            v-model.trim="form.gasName"
            placeholder="请输入加油站名称"
          />
        </el-form-item>
        <el-form-item
          label="加油站地址"
          prop="areaList"
          style="margin-right:15px"
        >
          <el-cascader
            v-model="form.areaList"
            :options="parentData.areaOptions"
            :props="{ value: 'countyCode', label: 'countyName', children: 'children' }"
            clearable
            @change="changeAreaList"
          />
        </el-form-item>
        <el-form-item
          label="详细地址"
          prop="address"
          style="margin-right:15px"
        >
          <el-input
            v-model.trim="form.address"
            placeholder="请输入详细地址"
          />
        </el-form-item>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import { validatePhone } from "@/utils/validate.js"
  export default {
    name: 'GasStationAdd',
    data() {
      // 验证名称不能含有空格
      const validateName = ( rule, value, callback ) => {
        const  reg =/\s/
        if(value){
          if( reg.test(value) ){
            callback( new Error("格式错误"));
          }else{
            callback()
          }
        }else{
          callback( new Error("请输入联系人"));
        }
      };
      // 验证名称不能含有空格
      const validateGasName = ( rule, value, callback ) => {
        const  reg =/\s/
        if(value){
          if( reg.test(value) ){
            callback( new Error("格式错误,不能包含空格"));
          }else{
            callback()
          }
        }else{
          callback( new Error("请输入加油站名称"));
        }
      }
      return {
      parentData: {
        areaOptions: this.$store.state.components.areaOptions
      },
        form: {
          name: '',
          gasBalance: '',
          paytyCode: '',
          gasName: '',
          areaList:[],
          branchCode: '',
          phone:'',
          address:''
        },
        rules: {
          name: [
            {required: true, validator: validateName, trigger: 'blur'},
		    	  { max:64, message: "不超过64字符" },
          ],
          phone: [{ required: true,
            validator(rule, value, callback) {
              validatePhone(value)
                ? callback()
                : callback(new Error("手机号格式有误"));
            }}],
          gasName: [
            {required: true, validator: validateGasName, trigger: 'blur'},
            { max:255, message: "不超过255字符"},
          ],
          areaList: [
            {required: true, message: '请选择加油地址', trigger: 'blur'},
          ],
          address: [
            {required: true, message: '请输入详细地址', trigger: 'blur'},
            {min:1, max: 255, message:'长度为1到255个字符'}
          ]
        }
      }
    },
    created() {
    },
    methods: {
    // 区域切换
    changeAreaList(value) {
      if (value.length > 0) {
        this.form.provinceCode = value[0];
        this.form.cityCode = value[1];
        this.form.countyCode = value[2];
      } else {
        this.form.provinceCode = "";
        this.form.cityCode = "";
        this.form.countyCode = "";
      }
    },
      //提交
      funcSubmit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            const rLoading = this.openLoading();
            const data = this.form
            request({url: '/ntocc-basic-api/gasStation/saveGasStation', method: 'post', params: data}).then(response => {
              rLoading.close();
              this.$message({message: response.msg, type: 'success'})
              this.$emit('fatherAddMethod')
            }).then(() => this.$refs['form'].resetFields())
          } else {
            return false;
          }
        });
      },
      //取消
      funcCancel() {
        this.$emit('fatherCancelMethod', 'add')
      }
    }
  }
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin: 15px 0 15px 0;
    width: 175px;
    float: right;
  }
</style>
